import * as React from "react";
import {Types}    from "@Common/types";
import {cx}       from "emotion";

import "./modal-layout.scss";

import {ButtonSpinner} from "@Common/ui-components/loading-spinners/button-spinner";
import {cs} from "@Common/react/chain-services";

export const ModalLayout = ({
    title         = undefined,
    content,
    buttons       = undefined,
    headerContent = undefined,
    footerContent = undefined,
    back          = false,
}:Types.Xpresso.Common.ModalLayout.ModalLayoutProps) => cs(
    () => (
        <div className="modal-layout-61w" xd-qa-type="modal" xd-qa-name={title}>
            {title && (
                <div className="header">
                    {!!back && (
                        <div className="back" onClick={() => window.history.back()} xd-qa-type="icon" xd-qa-name="Default Modal Back">
                            &lt; Back
                        </div>
                    )}
                    <div className="title" xd-qa-type="label" xd-qa-name={title}>
                        {title}
                    </div>
                    {headerContent}
                </div>
            )}

            <div className="content">
                {content}
            </div>

            {(buttons || footerContent) && <div className="footer">
                {footerContent}
                {buttons.map((button, i) => (
                    <button
                        key={i}
                        className={cx({primary: button.primary}, button.className)}
                        onClick={button.onClick}
                        disabled={button.disabled}
                        xd-qa-type="button"
                        xd-qa-name={button.label}
                    >
                        {button.label}{button.spinner && (<ButtonSpinner spinnerColor="white"/>)}
                    </button>
                ))}
            </div>}
        </div>
    )
);
